import { NextPage } from 'next';
import { GetServerSideProps } from 'next';
import BookDetail from '@/components/screens/book-detail/BookDetail';
import { API_URL } from '@/helpers/variables';
import { IBookDetailData } from '@/interfaces/bookDetail.interface';
import { IReviews } from '@/interfaces/reviews.interface';
import { IQuotes } from '@/interfaces/quotes.interface';
import { ISimilarBooks } from '@/interfaces/similarBooks.interface';
import { IBlog } from '@/interfaces/blog.interface';

interface IBookDetailPage {
  book: IBookDetailData;
  reviews: IReviews;
  quotes: IQuotes;
  similarBooks: ISimilarBooks;
  blogs: IBlog;
}

const BookDetailPage: NextPage<IBookDetailPage> = ({ book, reviews, quotes, similarBooks, blogs }) => {
  return <BookDetail book={book} reviews={reviews} quotes={quotes} similarBooks={similarBooks} blogs={blogs} />;
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const BLOG_BOOKS = 4;

  const { id } = context.query;

  const bookRes = await fetch(`${API_URL}satellite/books/${id}`);

  // Check fetch error
  if (!bookRes.ok) {
    console.table(`Error ${bookRes.status}. Api: ${bookRes.url}`);
    return {
      notFound: true,
    };
  }

  const book = await bookRes.json();

  // Check Fetched Data Error
  if (!book.id) {
    return {
      notFound: true,
    };
  }

  const [reviewsRes, quotesRes, similarBooksRes, blogsRes] = await Promise.all([
    fetch(`${API_URL}satellite/reviews/?book_id=${id}&page=1`),
    fetch(`${API_URL}satellite/quotes/?book_id=${id}&page=1&page_size=10`),
    fetch(`${API_URL}satellite/similar/book/${book.alias}`),
    fetch(`${`https://aldebaran.one/api/v1/`}satellite/posts?page=1&page_size=${BLOG_BOOKS}`),
  ]);
  const [reviews, quotes, similarBooks, blogs] = await Promise.all([reviewsRes.json(), quotesRes.json(), similarBooksRes.json(), blogsRes.json()]);

  return { props: { book, reviews, quotes, similarBooks, blogs } };
};

export default BookDetailPage;
